<button (click)="onClick($event)" class="add-button" [ngClass]="{ clicked: clicked }">
    <ng-container *ngIf="clicked">
        <img src="../../../../../assets/images/icon_close_dark.svg" />
        {{ 'SHARED.ADD_BUTTON.CANCEL' | translate }}
    </ng-container>
    <ng-container *ngIf="!clicked">
        <img src="../../../../../assets/images/icon_plus.svg" /> {{ text | translate }}
    </ng-container>
</button>
